

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import SidebarElement from '@/components/parts/catalog/card/components/sidebar/components/SidebarElement.vue';
import YesNo from '@/components/parts/catalog/card/components/sidebar/components/YesNo.vue';

const LINK_SUFFIX = 'profession';

@Component({
  components: {
    SidebarElement,
    YesNo,
  },
})
export default class ModuleSidebar extends Vue {
  @Prop({ type: Object, default: () => {} })
  readonly sidebar!: any;

  get isProfession() {
    return !!Object.keys(this.sidebar.profession).length;
  }

  get professonLink() {
    const { isProfession, sidebar } = this;
    return isProfession ? `/${LINK_SUFFIX}/${sidebar.profession.id}` : '';
  }

  get educationFormDictionary() {
    return this.$store.state.educationForm;
  }

  get educationForm(): string {
    const {
      educationFormDictionary,
      sidebar: { formEducationId },
    } = this;
    const result = educationFormDictionary.find(
      ({ id }: { id: number }) => id === parseInt(formEducationId, 10),
    );
    return result ? result.name : '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/modulesidebar/ModuleSidebar.vue